import _join from 'lodash/join';

class LocationsMapbox {

    constructor(){
        this._mapContainerName = 'location-map';
        this._mapBox = null;
        this._pickupMarker = null;
        this._pickupMarkerText = null;
        this._accommodationMarker = null;
        this._accommodationMarkerText = null; 
        this._duration = 0;
        this._distance = 0;
        this._coordinates = [];
    }

    get duration(){ return this._duration; }
    set duration(value){ this._duration = value; }

    get distance(){ return this._distance; }
    set distance(value){ this._distance = value; }

    get coordinates(){ return this._coordinates; }
    set coordinates(value){ this._coordinates = value; }

    initMap(){
        if(!window.mapboxgl.supported()) {
            alert('Your browser does not support Mapbox GL');
        }else{

            window.mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_API_TOKEN;
            this._mapBox = new window.mapboxgl.Map({
                container: this._mapContainerName,
                style: "mapbox://styles/ken-busabout/cjm91nhzo0cji2rnyd5jx50g4",
                center: [0, 0],
                zoom:15,
                hash:false
            });

            //Pickup marker 
            var pickupText = document.createElement('div');
            pickupText.className = "city-text pickup-marker";
            pickupText.innerHTML += "Meeting point";

            var pickupMarker = document.createElement('div');
            pickupMarker.className = "marker";
            pickupMarker.addEventListener('mouseenter', () => this.markerMouseOver('pickup-marker'));
            pickupMarker.addEventListener('mouseleave', () => this.markerMouseOut('pickup-marker'));

            //Accommodation marker   
            var accommodationText = document.createElement('div');
            accommodationText.className = "city-text hotel-marker";
            accommodationText.innerHTML += "Hotel";

            var accommodationMarker = document.createElement('div');
            accommodationMarker.className = "accommdation-marker";
            accommodationMarker.addEventListener('mouseenter', () => this.markerMouseOver('hotel-marker'));
            accommodationMarker.addEventListener('mouseleave', () => this.markerMouseOut('hotel-marker'));

            this._pickupMarker = new window.mapboxgl.Marker(pickupMarker).setLngLat([0, 0]).addTo(this._mapBox);
            this._pickupMarkerText = new window.mapboxgl.Marker(pickupText).setLngLat([10, 10]).addTo(this._mapBox);
            this._accommodationMarker = new window.mapboxgl.Marker(accommodationMarker).setLngLat([0, 0]).addTo(this._mapBox);
            this._accommodationMarkerText = new window.mapboxgl.Marker(accommodationText).setLngLat([0, 0]).addTo(this._mapBox);


            //Navigation controls
            this._mapBox.addControl(new window.mapboxgl.NavigationControl());
        }  
    }

    markerMouseOver(name){
      document.querySelector(`.${name}`).classList.add('active');
    }

    markerMouseOut(name){
      document.querySelector(`.${name}`).classList.remove('active');
    }

    updateCoordinates(locationArr){
        if(locationArr !== undefined){
            this._pickupMarker.setLngLat(locationArr);
            this._pickupMarkerText.setLngLat(locationArr);
            this._mapBox.flyTo({center:locationArr, speed: 10, zoom:15});
        }
    }

    removeAccommodationMarker(locationArr){

        //hide marker
        document.querySelector('.accommdation-marker').style.display = "none";

        //Check and remove any layer and source
        const routeLayer = this._mapBox.getLayer('route');
        if(typeof routeLayer !== 'undefined')  this._mapBox.removeLayer('route').removeSource('route');

        if(locationArr !== null) this._mapBox.flyTo({center:locationArr, speed: 10, zoom:15});

    }

    accommodationDirection(coordinates){
    
        var _coordinates = _join(coordinates, ';');
        
        var _url = "https://api.mapbox.com/directions/v5/mapbox/walking/" + _coordinates + ".json?access_token=" + process.env.REACT_APP_MAPBOX_API_TOKEN + "&alternatives=true&geometries=geojson&steps=false";
          return new Promise((resolve, reject) => {
          fetch(_url)
          .then(response => response.json())
          .then(json => { resolve(json.routes[0]);})
          .catch(e => { reject(); })
        });
    }


    async getAccommodationLocation(type = 'hotel', pickupLocation, hotelLocation){

       const {lat:pickUpDropOffLat, lon:pickUpDropOffLon} = pickupLocation;
       

       if(type === 'hotel'){
        
         this._pickupMarker.setLngLat(pickupLocation);
         this._pickupMarkerText.setLngLat(pickupLocation);

         this._mapBox.flyTo({center:pickupLocation, speed: 10, zoom:15});
         this._accommodationMarker.setLngLat(hotelLocation);
         this._accommodationMarkerText.setLngLat(hotelLocation);
         document.querySelector('.accommdation-marker').style.display = "block";
        

         const { lat:hotelLat, lon:hotelLon } = hotelLocation;
         const mergedArr = [...[[hotelLon, hotelLat]], ...[[pickUpDropOffLon, pickUpDropOffLat]]];
         const hotelDirections = await this.accommodationDirection(mergedArr);
     
         this._duration = (hotelDirections && hotelDirections.duration !== undefined) ? (hotelDirections.duration / 60).toFixed(2) : "";
         this._distance =  (hotelDirections && hotelDirections.distance !== undefined) ? (hotelDirections.distance / 1000).toFixed(2) : "";
         this._coordinates = hotelDirections.geometry.coordinates;
        
         await this.mapDrawLine(this._coordinates);
         await this.zoomToCenter(this._coordinates);
     
        //  console.log(
        //     'Hotel: ', 
        //     hotelDirections.geometry.coordinates, 
        //     `${hotelDirections.distance.toFixed(2)} in km`,
        //     `${(hotelDirections.duration / 60).toFixed(2)} in minutes`,
        //  )
 
         return {
            duration:this._duration,
            distance:this._distance
         }

     
       }

    }

    async zoomToCenter(coordinates){
        const _bounds = coordinates.reduce((bounds, coord) => {
              return bounds.extend(coord);
        }, new window.mapboxgl.LngLatBounds(coordinates[0], coordinates[0]));
    
        this._mapBox.fitBounds(_bounds, {padding: 60, maxDuration:3});
    }

    async mapDrawLine(coordinates){
 
      //Check and remove any layer and source
      const routeLayer = this._mapBox.getLayer('route');
      if(typeof routeLayer !== 'undefined')  this._mapBox.removeLayer('route').removeSource('route');
  
      var route = {
        "type": "FeatureCollection",
        "features": [{
          "type": "Feature",
          "geometry": {
            "type": "LineString",
            "coordinates": coordinates
          }
        }]
      };
  
      this._mapBox.addSource('route', {"type": "geojson", "data": route});
      this._mapBox.addLayer({
        "id": "route",
        "source": "route",
        "type": "line",
        "paint": {
          "line-width": 3,
          "line-color": "#ff6700"
        }
      });
      
    }

}

export default LocationsMapbox;